import { css, html, LitElement } from "lit";
import { property } from "lit/decorators/property.js";
import "@shoelace-style/shoelace/dist/components/badge/badge.js";

type Promo = {
  "promo-text-long": string;
  "promo-text-short": string;
};

export class BeamPromoInfoPill extends LitElement {
  @property({ type: Object }) promo: Promo | null = null;
  @property({ type: Boolean }) shortVersion = false;

  static get styles() {
    return css`
      sl-badge::part(base) {
        background-color: var(--beam-promoPillLabel-color-background, #000);
        color: var(--beam-promoPillLabel-color, #fff);
        border: var(--beam-promoPillLabel-border-width, 0px) solid var(--beam-promoPillLabel-border, #000);
        border-radius: 18.37px;
        font-family: var(--beam-promoPillLabel-font, inherit);
        font-size: var(--beam-promoPillLabel-font-size, 12px);
        font-weight: var(--beam-promoPillLabel-font-weight, bold);
        text-transform: var(--beam-promoPillLabel-text-transform, none);
        text-wrap: var(--beam-promoPillLabel-text-wrap, wrap);
        padding: var(--beam-promoPillLabel-text-padding);
        margin: var(--beam-promoPillLabel-border-margin);
      }
    `;
  }

  render() {
    if (this.promo) {
      const promoText = this.shortVersion ? this.promo["promo-text-short"] : this.promo["promo-text-long"];
      return html`<sl-badge pill aria-label="${promoText}">${promoText}</sl-badge>`;
    } else {
      return html``;
    }
  }
}

customElements.get("beam-promo-info-pill") || customElements.define("beam-promo-info-pill", BeamPromoInfoPill);

export const promoPillLabelConfigDefaults = {
  "--beam-promoPillLabel-color-background": "#000",
  "--beam-promoPillLabel-color": "#fff",
  "--beam-promoPillLabel-border": "#000",
  "--beam-promoPillLabel-border-width": "0px",
  "--beam-promoPillLabel-font-size": "11px",
  "--beam-promoPillLabel-font": "inherit",
  "--beam-promoPillLabel-font-weight": "bold",
  "--beam-promoPillLabel-text-transform": "none",
  "--beam-promoPillLabel-text-wrap": "wrap",
  "--beam-promoPillLabel-text-padding": "4px 15px",
  "--beam-promoPillLabel-border-margin": "0px",
} as const;

declare global {
  interface HTMLElementTagNameMap {
    "beam-promo-info-pill": BeamPromoInfoPill;
  }
}
